export const modalLayoutTheme = {
    layout: {
        spacing: {
            vertical: (props) => props.theme.spacing.lg,
            horizontal: (props) => props.theme.spacing.lg,
        },
        box: {
            shadow: (props) => props.theme.shadow.sm,
            background: {
                color: (props) => props.theme.palette.surface,
            },
            margin: (props) => props.theme.spacing.md,
        },
        header: {
            background: {
                color: (props) => props.theme.palette.surface,
            },
            accent: {
                background: {
                    color: (props) => props.theme.palette.surfaceAlt,
                },
            },
        },
        content: {
            background: {
                color: (props) => props.theme.palette.surface,
            },
        },
        footer: {
            background: {
                color: (props) => props.theme.palette.surface,
            },
            accent: {
                background: {
                    color: (props) => props.theme.palette.surface,
                },
                borderTop: {
                    width: '1px',
                    color: (props) => props.theme.palette.secondaryAlt,
                },
            },
            spacing: {
                buttons: (props) => props.theme.spacing.xs,
            },
        },
    },
    border: { radius: (props) => props.theme.radius.lg },
};
